/**
 * 仓库同源 Markdown 渲染（评测报告、方法沉淀 skill 全文）：内容来自仓库、走 PR 评审，不是用户输入。
 * 用 marked（GFM：表格、删除线、任务列表）转 HTML，样式按后台排版收在本组件里，不引全局 prose。
 */
import { marked } from "marked";
import { useMemo } from "react";

import { cn } from "@/lib/utils";

const MD = cn(
	"text-sm leading-6 text-text-primary",
	"[&_h1]:mb-3 [&_h1]:mt-2 [&_h1]:text-lg [&_h1]:font-semibold",
	"[&_h2]:mb-2 [&_h2]:mt-6 [&_h2]:border-b [&_h2]:border-surface-border [&_h2]:pb-1 [&_h2]:text-base [&_h2]:font-semibold",
	"[&_h3]:mb-2 [&_h3]:mt-4 [&_h3]:text-sm [&_h3]:font-semibold",
	"[&_h4]:mb-1 [&_h4]:mt-3 [&_h4]:text-sm [&_h4]:font-medium",
	"[&_p]:my-2 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5",
	"[&_blockquote]:my-2 [&_blockquote]:border-l-2 [&_blockquote]:border-surface-border [&_blockquote]:pl-3 [&_blockquote]:text-text-secondary",
	"[&_code]:rounded-md [&_code]:bg-surface-muted [&_code]:px-1 [&_code]:font-mono [&_code]:text-xs",
	"[&_pre]:my-2 [&_pre]:overflow-x-auto [&_pre]:rounded-md [&_pre]:bg-surface-muted [&_pre]:p-3 [&_pre_code]:bg-transparent [&_pre_code]:p-0",
	"[&_table]:my-3 [&_table]:block [&_table]:max-w-full [&_table]:overflow-x-auto [&_table]:border-collapse [&_table]:text-xs",
	"[&_th]:border [&_th]:border-surface-border [&_th]:bg-surface-muted [&_th]:px-2 [&_th]:py-1 [&_th]:text-left [&_th]:font-medium",
	"[&_td]:border [&_td]:border-surface-border [&_td]:px-2 [&_td]:py-1 [&_td]:align-top",
	"[&_a]:text-brand-accent [&_a]:underline [&_hr]:my-4 [&_hr]:border-surface-border [&_strong]:font-semibold",
);

export function Markdown({
	text,
	className,
	testId,
}: { text: string; className?: string; testId?: string }) {
	const html = useMemo(
		() => marked.parse(text ?? "", { gfm: true, async: false }) as string,
		[text],
	);
	return (
		<div
			className={cn(MD, className)}
			data-testid={testId}
			// biome-ignore lint/security/noDangerouslySetInnerHtml: 内容来自仓库 md（PR 评审过），不是用户输入
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	);
}
